import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAppLanguage } from '../Hooks/useAppLanguage';

const isTokenValid = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;
        if (decoded.exp && decoded.exp > now) return true;
    } catch (err) {
        // Ignore invalid token
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    return false;
};

const ProtectedRoute = ({ children }) => {
    const { currentLanguage } = useAppLanguage();
    if (!isTokenValid()) {
        return <Navigate to={`/${currentLanguage || 'en'}/sign-in`} replace />;
    }
    return children;
};

export default ProtectedRoute;
